import React, { Component } from "react";

import "../App.css";
import "../css/style.css";
import "../css/bootstrap.css";
import logo from "../Assets/mathisadmission.png";

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      password: "",
      token: "",
    };
  }
  render() {
    return (
      <div className="App">
        <div className="navigation">
          <img
            className="website-logo"
            src={logo}
            alt="Logo Mathis Admission"
          />
          <h1 className="website-title-text">Prepa Tage Mage</h1>
        </div>

        <div className="row" style={{ marginTop: 40, marginBottom: 40 }}>
          <div className="col">
            <h2 className="menu-principal-text">Menu principal</h2>
          </div>
        </div>

        <div className="container">
          <div className="row">
            <div className="col-12 col-lg-4 col-button">
              <a className="exercice-button" href="/cubes">
                Cubes
              </a>
              <a className="exercice-button" href="/carres">
                Carrés
              </a>
              <a className="exercice-button" href="/ratios">
                Ratio
              </a>
              <a className="exercice-button" href="/racine">
                Racine
              </a>
              <a className="exercice-button" href="/alphabet">
                Alphabet
              </a>
              <a className="exercice-button" href="/addition">
                Addition
              </a>
              <a className="exercice-button" href="/division">
                Division
              </a>
            </div>
            <div className="col-12 col-lg-4 col-button">
              <a className="exercice-button" href="/table13">
                Table de 13
              </a>
              <a className="exercice-button" href="/table17">
                Table de 17
              </a>
              <a className="exercice-button" href="/table19">
                Table de 19
              </a>
              <a className="exercice-button" href="/puissance2">
                Puissance de 2
              </a>
              <a className="exercice-button" href="/puissance3">
                Puissance de 3
              </a>
              <a className="exercice-button" href="/soustraction">
                Soustraction
              </a>
              <a className="exercice-button" href="/rapports">
                Rapports
              </a>
            </div>
            <div className="col-12 col-lg-4 col-button">
              <a
                className="exercice-button"
                href="/heures"
                aria-disabled="true"
              >
                Conversion heures
              </a>
              <a className="exercice-button" href="/parite">
                Parité
              </a>
              <a className="exercice-button" href="/divisibilite">
                Critère de divisibilité
              </a>
              <a className="exercice-button" href="/favorites">
                Nombres des concepteurs
              </a>
              <a className="exercice-button" href="/multiplication">
                Multiplication
              </a>
              <a className="exercice-button" href="/pourcentage">
                Pourcentage
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Home;
